import styled, { css } from 'styled-components';
import { TransitionDirection } from 'ggApp/modules/stepper/utils/enums';

export const ANIMATION_DURATION_IN_MS = 300;

const transitionStyle = css`
    transition-property: transform, opacity;
    transition-duration: ${ANIMATION_DURATION_IN_MS}ms;
    transition-timing-function: ease;
`;

const getAnimationTranslate = (isReverted: boolean) => ({
    transitionDirection,
}: {
    transitionDirection: TransitionDirection;
}) => {
    const isBackward = transitionDirection === TransitionDirection.backward;
    const animationSign = isBackward ? -1 : 1;
    const revertedSign = isReverted ? -1 : 1;

    return `
        translateX(${100 * animationSign * revertedSign}%)
    `;
};

export const Container = styled.div`
    position: relative;
    flex-grow: 1;
    flex-shrink: 0;

    display: flex;
    flex-direction: column;

    overflow-x: hidden;
`;

export const Content = styled.div<{ transitionDirection: TransitionDirection }>`
    width: 100%;

    flex: 1 0 auto;

    display: flex;
    flex-direction: column;

    &.step-content-exit-active {
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        overflow: hidden;
    }

    &.step-content-enter {
        opacity: 0;
        transform: ${getAnimationTranslate(false)};
    }

    &.step-content-enter-active,
    &.step-content-enter-done {
        opacity: 1;
        transform: translateX(0);
        ${transitionStyle}
    }

    &.step-content-exit {
        opacity: 1;
        transform: translateX(0);
    }

    &.step-content-exit-active,
    &.step-content-exit-done {
        opacity: 0;
        transform: ${getAnimationTranslate(true)};
        ${transitionStyle}
    }
`;
